import { render, staticRenderFns } from "./InformationPublish.vue?vue&type=template&id=bd07dcfa&scoped=true&"
import script from "./InformationPublish.vue?vue&type=script&lang=js&"
export * from "./InformationPublish.vue?vue&type=script&lang=js&"
import style0 from "./InformationPublish.vue?vue&type=style&index=0&id=bd07dcfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd07dcfa",
  null
  
)

export default component.exports